import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import TicketStore from "../../stores/TicketStore";
import PassStore from "../../stores/PassStore";
import AddPassToCartButton from "./add-pass-to-cart-button.jsx";
import AddTicketToCartButton from "./add-ticket-to-cart-button.jsx";


class AddToCartButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  static getStores() {
    return [TicketStore, PassStore];
  }

  static getPropsFromStores() {
    return {};
  }

  getStyles() {
    return {
      button: {}
    };
  }

  render() {
    const { 
      enable_cart
    } = this.context.appSettings;

    let styles = this.getStyles(),
      { buyingAdditionalTickets } = this.state,
      { passBucketId, eventId, appSettings, label, style } = this.props;

    // EE informational error message
    if (!enable_cart) {
      console.log("Eventive Everywhere Add to Cart Button: Render failed - cart is not enabled for this event bucket");
    }
    if (!passBucketId && !eventId) {
      console.log("Eventive Everywhere Add to Cart Button: Render failed due to missing data-pass-bucket-id or data-event-id attribute value");
    }
    if (passBucketId && eventId) {
      console.log("Eventive Everywhere Add to Cart Button: Render failed - cannot use both data-pass-bucket-id and data-event-id attributes at the same time");
    }

    return (
      <div style={{ position: "relative" }}>
        {eventId && !passBucketId ? 
          <AddTicketToCartButton
            event={eventId}
            label={label}
            style={style}
          />
         : passBucketId && !eventId ? (
          <AddPassToCartButton
            passBucketId={passBucketId}
            label={label}
            style={style}
          />
        ) : null}
      </div>
    );
  }
}

export default connectToStores(AddToCartButton);



// WEBPACK FOOTER //
// ./src/app/components/partials/add-to-cart-button.jsx